import { render, staticRenderFns } from "./TheDataTable.vue?vue&type=template&id=04f2a27e&scoped=true"
import script from "./TheDataTable.vue?vue&type=script&lang=js"
export * from "./TheDataTable.vue?vue&type=script&lang=js"
import style0 from "./TheDataTable.vue?vue&type=style&index=0&id=04f2a27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2a27e",
  null
  
)

export default component.exports